import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum ProcessAreaPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
}

export const ProcessAreaResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.PROCESS_AREA).default(ResourceType.PROCESS_AREA),
    description: z.string(),
});
export const ProcessAreaMutationResourceSchema = getMutationSchema(ProcessAreaResourceSchema);

export type ProcessAreaResource = z.infer<typeof ProcessAreaResourceSchema>;

export const defaultProcessAreaResource: ProcessAreaResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.PROCESS_AREA,
    description: '',
};

export function useProcessAreaActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/process-area',
            ResourceType.PROCESS_AREA,
            ProcessAreaResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/process-area',
            ResourceType.PROCESS_AREA,
            ProcessAreaResourceSchema
        ),
    };
}
